import { motion } from "framer-motion";
import { ArrowRight, Clock3, MessageCircle, QrCode } from "lucide-react";
import { openWhatsApp, parsePrice } from "@/lib/site";

export const tiersOf = (event) => [
  { key: "couple", label: "Couple", price: event.price_couple },
  { key: "male", label: "Stag", price: event.price_male },
  { key: "female", label: "Female", price: event.price_female },
].filter((t) => parsePrice(t.price) > 0);

const fromPrice = (event) => {
  const tiers = tiersOf(event);
  if (!tiers.length) return event.price;
  return `₹${Math.min(...tiers.map((t) => parsePrice(t.price))).toLocaleString("en-IN")}`;
};

const EASE = [0.16, 1, 0.3, 1];

export const EventsSection = ({ events, onBuy }) => (
  <section className="event-section" id="events" data-testid="events-section">
    <div className="section-head">
      <div>
        <p className="chapter"><b>01</b> The next chapter</p>
        <h2>What’s <em>on.</em></h2>
        <p className="section-intro">This week’s Bollywood & commercial nights at Baga’s favourite nightclub — new lineups every week.</p>
      </div>
      <a href="#events" className="text-link" data-testid="view-all-events-link">View all events <ArrowRight size={15}/></a>
    </div>
    {events.length === 0 && (
      <div className="events-empty" data-testid="events-empty">
        <p className="kicker">Lineup loading</p>
        <h3>This week’s nights <em>drop soon.</em></h3>
        <p className="muted">The next lineup is being announced — message us on WhatsApp for tonight’s plan.</p>
        <button className="button button-pink" onClick={() => openWhatsApp("Hi Soho Goa, what's on this week?")} data-testid="events-empty-whatsapp"><MessageCircle size={17}/> Ask what’s on</button>
      </div>
    )}
    <div className="event-grid">
      {events.map((event, i) => (
        <motion.article
          className={`event-card ${event.featured ? "featured" : ""}`}
          key={event.id}
          data-testid={`event-card-${event.id}`}
          initial={{ opacity: 0, y: 64 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-70px" }}
          transition={{ duration: 0.95, ease: EASE, delay: i * 0.13 }}
        >
          <div className="event-photo">
            <img src={event.image} alt={`${event.title} — Bollywood night at Soho Goa, nightclub in Baga`} loading="lazy"/>
            <span className="event-tag">{event.featured ? "This Saturday" : "Coming up"}</span>
            <div className="date-block"><strong>{event.date}</strong><span>{event.month}</span></div>
          </div>
          <div className="event-info">
            <p className="event-weekday">{event.weekday}</p>
            <h3>{event.title}</h3>
            <p className="muted">{event.genre}</p>
            {tiersOf(event).length > 0 && <p className="tier-line">{tiersOf(event).map((t) => `${t.label} ${t.price}`).join(" · ")}</p>}
            <div className="event-details"><span><Clock3 size={14}/>{event.time}</span><span className="price">From {fromPrice(event)}</span></div>
            <div className="card-actions">
              <button className="button button-small button-pink" onClick={() => onBuy(event)} data-testid={`buy-cover-${event.id}`}>Get cover charge <QrCode size={14}/></button>
              <button className="icon-btn" onClick={() => openWhatsApp(`Hi Soho Goa, I'd like to reserve a table for ${event.title}.`, event.title)} aria-label={`Reserve for ${event.title}`} data-testid={`reserve-event-${event.id}`}><MessageCircle size={17}/></button>
            </div>
          </div>
        </motion.article>
      ))}
    </div>
  </section>
);
